export default __webpack_public_path__ + "static/media/scw-grid-12.ea8dfd87.svg";